import { Role } from "../../Helpers/AuthorizationDataProvider";

export enum Status {
	Pending = 'Pending',
	Active = 'Active',
	Rejected = 'Rejected',
	Accepted = 'Accepted',
}

export interface Field {
	dependency?: Role
	extraClass: string
	id: string
}

export interface ApplicantMenteeUpgradeRequestResponse {
	createdBy: {
		firstName: string
		imageId?: string
		isActive: boolean
		isDeleted: boolean
		lastName: string
		location: string
		reinvite: boolean
		rocketUserId: string
		role: Role
		userId: string
	}
	upgradeApplicantMentee: {
		conference: string
		createdAt: string
		firstName: string
		id: string
		lastName: string
		status: Status
		userId: string
	}
}

export interface  ApplicantMenteeUpgradeRequestModel {
	[key: string]: any
	conference: string
	createdAt: string
	status: Status
	userId: string
}

export interface UserProfileResponse {
	[key: string]: any
	acceptedAt: string
	currentPosition?: string
	education: string[]
	firstName: string
	imageId: string
	introduction?: string
	languages?: string[]
	lastName: string
	location?: string
	pronouns?: 'she_her' | 'he_him'| 'they_them'
	researchAreas?: string[]
	role: Role
	title?: 'ms' | 'mrs' | 'mr' | 'dr'
	workExperience: string[]
}

export interface UserProfileModel {
	[key: string]: any
	currentPosition?: string
	education: string[]
	email: string
	imageId: string
	languages?: string[]
	location?: string
	name: string
	researchAreas?: string[]
	role: Role
	workExperience: string[]
}